import React from 'react';
import Toggle from 'react-toggle';
import Wrapper from './styles';

const Index = (props) => {
  return (
    <Wrapper>
      {}
      <Toggle icons={false} {...props} />
    </Wrapper>
  );
};

export default Index;
